import React from "react"
import { MobileMenu } from "component/macro/layout/modal/MobileMenu"
import { TemporaryEditor } from "component/macro/layout/modal/TemporaryEditor"
import { EGrads } from "libs/style/styling"
import { CtxModal } from "component/modal/ctxModal"
import { EScrolls } from "libs/utils/logic/browserLogic"
import { useContext } from "react"
import styled, { css } from "styled-components/macro"
import { Localization } from "libs/localization/localization"

interface Props {
  className?: string
}

export const ModalContent = (props: Props): JSX.Element => {
  const ctxModal = useContext(CtxModal)

  return (
    <S_ModalContent className={props.className} modal={ctxModal.modal}>
      {ctxModal.modal === "mobileMenu" && (
        <MobileMenu
          items={[
            {
              name: Localization.USECASES,
              scroll: EScrolls.everywhere,
            },
            {
              name: Localization.EDITOR,
              scroll: EScrolls.editor,
            },
            {
              name: Localization.FAQ,
              scroll: EScrolls.faq,
            },
            // {
            //   name: Localization.PRICING,
            //   scroll: EScrolls.pricing,
            // },
            {
              name: Localization.CONTACT,
              scroll: EScrolls.contact,
            },
          ]}
        />
      )}
      {ctxModal.modal === "temporary" && <TemporaryEditor />}
    </S_ModalContent>
  )
}

const S_ModalContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  ${props => {
    if (props.modal === "mobileMenu") {
      return css`
        background-color: white;
      `
    } else if (props.modal === "temporary") {
      return css`
        background: ${EGrads.ACC2_GRAD};
      `
    }
  }}
  //hack to keep padding
    &:after {
    content: "";
    display: block;
    height: 0px;
    width: 100%;
  }
  @media only screen and (min-width: 1260px) {
    padding: 0;
    height: unset;
    &::-webkit-scrollbar,
    &::-webkit-scrollbar {
      width: 15px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(white, 0.5);
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c7cbd1;
      border-radius: 0px;
      // border: 1px solid white;
    }
  }
`
